import React from 'react';
import {Link} from 'react-router-dom'

const SingleVitamin = ({foodNutrients, foodNutrient,
    //  visibility, 
    //  setVisibility
    // query, setQuery, 
    // getQuery
    }) => {
    const { id, name, image } = foodNutrient;

// const onClick=(q)=>{
//     setQuery(q)
//    getQuery(q)
   
// }

    return (
      
    <div key={id} className='nutrient-div'   style={{ maxWidth:'300px', margin:'0', padding:'0', overflow:'hidden', position: 'relative'}} 
    // onClick={(e)=>onClick(name)  }
    >
<Link to={`/vitamins/${name}`}>
      <img src={image} alt="" className='vitamins-image'/>
       
</Link>
        
      <h2 className='vitamins-name'
        //   visibility?'visible-name' :'vitamins-name'
       
          >{name}</h2>
    </div>



    )
}

export default SingleVitamin
